import Vue from 'vue';
import Vuex from 'vuex';
import auth from './Modules/auth/auth.store';
import notification from './Modules/common/notification.store';
import settings from './Modules/public/settings.store';
import overlay from './Modules/common/overlay.store';
import userEditor from './Modules/admin/userEditor.store';
import professionEditor from './Modules/admin/professionEditor.store';
import stepEditor from './Modules/admin/stepEditor.store';
import faqEditor from './Modules/admin/faqEditor.store';
import sectionEditor from './Modules/admin/sectionEditor.store';
import pageEditor from './Modules/admin/pageEditor.store';
import cardEditor from './Modules/admin/cardEditor.store';
import fieldEditor from './Modules/Field/Editor/fieldEditor.store';
import populationEditor from './Modules/admin/populationEditor.store';
import paletteEditor from './Modules/admin/paletteEditor.store';
import fontPairingEditor from './Modules/admin/fontPairingEditor.store';
import mediaLibrary from './Modules/admin/media.store';
import site from './Modules/public/site.store';
import page from './Modules/public/page.store';
import sidebar from './Modules/common/sidebar.store';
import websiteDesign from './Modules/public/websiteDesign.store';
import imageSelector from './Modules/common/imageSelector.store';

import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        notification,
        settings,
        overlay,
        cardEditor,
        sectionEditor,
        pageEditor,
        stepEditor,
        faqEditor,
        userEditor,
        professionEditor,
        fieldEditor,
        populationEditor,
        mediaLibrary,
        site,
        page,
        sidebar,
        paletteEditor,
        fontPairingEditor,
        websiteDesign,
        imageSelector
    },

    state: {
        heartbeat: '√v^√v^√v^√v^√√v^√v^√√v^√v^√√v^√v^√√v^√v^√√v^√v^√√√v^√v^√√v^√v^√',
        notification: {
            active: false,
            color: '',
            text: '',
            icon: '',
        },
        apiError: false,
    },
    mutations: {
        setApiError(state, apiError) {
            state.apiError = apiError;
        }
    },
    getters: {
        getHeartbeat(state) {
            return state.heartbeat;
        },

        getApiError(state) {
            return state.apiError;
        }
    },
    actions: {
        heartbeat() {
            return axios
                .get('/api/heartbeat')
                .then((response) => {
                    return {
                        status: response.status,
                        message: this.getters.getHeartbeat,
                    };
                })
                .catch((error) => {
                    return error;
                });
        },

        SET_API_ERROR({ commit }, error) {
            commit('setApiError', error);
        }
    },
});
